void main() {
    glFragColor = vec4(1.0);
}
